import EditAmountForm from './EditAmountForm';

export default EditAmountForm;
